import React from 'react';
import { emergentStats } from '../data/mock';

/* The Emergent numbers, shown inside the Emergent section as one ink panel
   with four equal cells. Spend is "$50M+ yearly". */
const StatsStrip = () => (
  <div
    aria-label="At Emergent, in numbers"
    className="bg-ink text-cream rounded-xl border-[1.5px] border-ink shadow-hard overflow-hidden"
  >
    <dl className="grid grid-cols-2 md:grid-cols-4 gap-px bg-cream/15">
      {emergentStats.map((stat) => (
        <div key={stat.label} className="bg-ink p-4 sm:p-6 flex flex-col">
          <dd className="order-1 text-3xl sm:text-[2.6rem] font-bold tracking-[-0.03em] leading-none">
            {stat.value}
          </dd>
          <dt className="order-2 mt-3 text-[11px] sm:text-xs font-bold uppercase tracking-label text-marker leading-snug">
            {stat.label}
          </dt>
          <dd className="order-3 mt-1 text-[12px] sm:text-[13px] text-cream/70 leading-snug">
            {stat.detail}
          </dd>
        </div>
      ))}
    </dl>
  </div>
);

export default StatsStrip;
